"use client";

import { cn } from "@/util";
import { Dialog as RDialog } from "radix-ui";
import type { ReactNode } from "react";

export interface DialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
  overlayClassName?: string;
  children?: ReactNode;
  content?: ReactNode;
}

export const Dialog = ({
  children,
  content,
  open,
  setOpen,
  className,
  overlayClassName,
}: DialogProps) => (
  <RDialog.Root open={open} onOpenChange={setOpen}>
    <RDialog.Trigger asChild>{children}</RDialog.Trigger>
    <RDialog.Portal>
      <RDialog.Overlay
        className={cn(
          "fixed inset-0 bg-[#000]/30 backdrop-blur-sm z-20 cursor-pointer data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut",
          overlayClassName
        )}
      />
      <RDialog.Content
        className={cn(
          "lxy-fixed-center z-20 backdrop-blur-xl h-drawer w-[90vw] overflow-hidden border rounded-3xl data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut",
          className
        )}
      >
        {content ?? children}
      </RDialog.Content>
    </RDialog.Portal>
  </RDialog.Root>
);
